const devBaseUrl = "http://10.0.5.250:20002/";
// const devBaseUrl = "http://localhost:20002/";

const prodBaseUrl = "https://arp-flat.xkool.ai/api";

export const baseUrl =
  process.env.NODE_ENV === "production" ? prodBaseUrl : devBaseUrl;
